module.exports = __webpack_public_path__ + "img/hat-2.e98dfc10.svg";